<template>
  <div class="page">
    <a-row :gutter="16">
      <a-col :span="24">
        <a-card title="上传视频" :bordered="false">
          <a-upload-dragger
            name="file"
            :multiple="false"
            :show-upload-list="false"
            :before-upload="beforeUpload"
            accept="video/*"
            :disabled="uploading"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">点击或拖拽视频到此处上传</p>
            <p class="ant-upload-hint">支持 mp4 / avi / mov / mkv / webm；H.265 会自动转为浏览器可播放的 H.264</p>
          </a-upload-dragger>
          <a-progress v-if="uploading" :percent="uploadPercent" style="margin-top: 16px" />
          <div v-if="lastUpload" class="result-box">
            <a-alert type="success" show-icon message="上传成功，已生成观看链接" />
            <div class="link-row">
              <span class="label">观看链接：</span>
              <a :href="lastUpload.watchUrl" target="_blank">{{ lastUpload.watchUrl }}</a>
              <a-button size="small" type="link" @click="copyLink(lastUpload.watchUrl)">复制</a-button>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>

    <a-card title="按文件名查找" :bordered="false" style="margin-top: 16px">
      <div class="search-bar">
        <a-input-search
          v-model="keyword"
          placeholder="输入文件名关键字"
          enter-button="搜索"
          allow-clear
          @search="handleSearch"
        />
      </div>
      <a-table
        :columns="columns"
        :data-source="list"
        :loading="loading"
        row-key="id"
        :pagination="{ pageSize: 10 }"
      >
        <template slot="fileSize" slot-scope="text">
          {{ formatSize(text) }}
        </template>
        <template slot="watchUrl" slot-scope="text">
          <a :href="text" target="_blank">{{ text }}</a>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-button type="link" size="small" @click="copyLink(record.watchUrl)">复制链接</a-button>
          <a-button type="link" size="small" @click="$router.push(`/watch/${record.shareCode}`)">观看</a-button>
          <a-popconfirm title="确认删除该视频？" ok-text="删除" cancel-text="取消" @confirm="handleDelete(record)">
            <a-button type="link" size="small" style="color: #ff4d4f">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { uploadVideo, searchVideo, deleteVideo } from '../api/video'

export default {
  name: 'Home',
  data() {
    return {
      uploading: false,
      uploadPercent: 0,
      lastUpload: null,
      keyword: '',
      loading: false,
      list: [],
      columns: [
        { title: '文件名', dataIndex: 'originalName', ellipsis: true },
        { title: '大小', dataIndex: 'fileSize', scopedSlots: { customRender: 'fileSize' }, width: 120 },
        { title: '观看链接', dataIndex: 'watchUrl', scopedSlots: { customRender: 'watchUrl' }, ellipsis: true },
        { title: '上传时间', dataIndex: 'createTime', width: 180 },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, width: 240 }
      ]
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    beforeUpload(file) {
      this.doUpload(file)
      return false
    },
    async doUpload(file) {
      this.uploading = true
      this.uploadPercent = 0
      try {
        const res = await uploadVideo(file, e => {
          if (e.total) {
            this.uploadPercent = Math.round((e.loaded / e.total) * 100)
          }
        })
        this.lastUpload = res.data
        this.$message.success('上传成功')
        this.handleSearch()
      } catch (e) {
        // 错误提示已在拦截器处理
      } finally {
        this.uploading = false
      }
    },
    async handleSearch() {
      this.loading = true
      try {
        const res = await searchVideo(this.keyword)
        this.list = res.data || []
      } catch (e) {
        this.list = []
      } finally {
        this.loading = false
      }
    },
    async handleDelete(record) {
      try {
        await deleteVideo(record.id)
        this.$message.success('已删除')
        this.handleSearch()
      } catch (e) {
        // 拦截器已提示
      }
    },
    formatSize(size) {
      if (!size && size !== 0) return '-'
      const units = ['B', 'KB', 'MB', 'GB']
      let n = size
      let i = 0
      while (n >= 1024 && i < units.length - 1) {
        n /= 1024
        i++
      }
      return `${n.toFixed(i === 0 ? 0 : 1)} ${units[i]}`
    },
    copyLink(link) {
      if (!link) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(() => {
          this.$message.success('链接已复制')
        })
        return
      }
      const input = document.createElement('input')
      input.value = link
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('链接已复制')
    }
  }
}
</script>

<style scoped>
.page {
  max-width: 1100px;
  margin: 0 auto;
}
.result-box {
  margin-top: 16px;
}
.link-row {
  margin-top: 12px;
  word-break: break-all;
}
.label {
  color: rgba(0, 0, 0, 0.65);
  margin-right: 8px;
}
.search-bar {
  margin-bottom: 16px;
  max-width: 420px;
}
</style>
